export default {
  namespaced: true,
  operational_procedure: {
    title: "Operational Procedure",
    simulacrums_title: "Operational Procedure",
    new: "New Operational Procedure",
    reference_number: "Reference Number",
    select_form: "Select form(s)",
    select_form_place_holder: "Select a form",
    selected_form: "Selected form",
    answer_form: "Start form",
    confirm_delete: "Are you sure you want to delete this simulacrum?",
    no_records: "No operation procedures found",
    reassign: "Reassign",
    template: {
      title: "Form Templates",
    },
    confirm_cancel: "Are you sure you want to cancel this operational procedure?",
    canceled: "Operational procedure canceled",
    reassigned: "Reassigned",
  },
  operational_procedure_exercise: {
    title: "Operational Exercise",
    new: "New Operational Exercise",
    template: {
      title: "Form Templates",
    },
  },
};


